import { Navigate } from 'react-router-dom';

function AuthGuard({ children }) {
  const token = sessionStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
}

export default AuthGuard;